import CurrentMarker from './CurrentMarker';

export default CurrentMarker;
